import React from "react";

import MyTasksCard from "./Task/MyTasksCard";
import ThisTheme from "../../../themes/CentricTheme";


function CENTWidget ({appCode}) {

    return (
        <React.Fragment>
            <MyTasksCard appCode={appCode} theme={ThisTheme}/>
        </React.Fragment>
    );

}

export default CENTWidget;